import utilsService from '@/api/utilsService.vue';

/**
 * Mixin global: expone en TODOS los componentes las banderas de permisos de
 * escritura, para no repetir la lógica de rol en cada vista.
 *
 *   puedeEscribir  -> false para perfiles de solo lectura (ej. "visita")
 *   esSoloLectura  -> inverso de puedeEscribir
 *
 * Uso en templates:
 *   <b-button v-if="puedeEscribir" ...>Guardar</b-button>
 *   <input :readonly="!puedeEscribir" ...>
 *
 * Uso en métodos (defensa ante llamadas directas):
 *   if (!this.puedeEscribir) return;
 */
export default {
  computed: {
    puedeEscribir() {
      return utilsService.puedeEscribir();
    },
    esSoloLectura() {
      return utilsService.esSoloLectura();
    },
  },
};
